module.exports = __webpack_public_path__ + "static/wave7-d3cfb05f0e39b2640bec71808797a02c.png";